import produce from 'immer'
import { QuestionStepSchema } from '@feedyou/schema'

import { UnsetDialogsService } from '../../../types'

export const unsetDialogs: UnsetDialogsService<QuestionStepSchema> = (dialogIds, step) => {
  return produce(step, result => {
    result.answers?.forEach(answer => {
      if (answer.dialog && dialogIds.includes(answer.dialog)) {
        answer.dialog = undefined
      }
    })

    if (result.defaultAnswer?.dialog && dialogIds.includes(result.defaultAnswer.dialog)) {
      result.defaultAnswer.dialog = undefined
    }
  })
}
